import axios from "axios";
import {getAPIUrl} from '../config'
import { headerConfig } from "./authConfig";
import { clearLocalStorage } from "./userStorage";

const serviceEndPoint = `${getAPIUrl()}/api/state`;

const handleApiError = (error, showToast) => {
    const status = error.response?.status || "Network Error";
    const message = error.response?.data?.message || error.message;

    if (showToast) {
        showToast(message, "error"); 
    }
    setTimeout(() => {
        clearLocalStorage(); 
    }, 500);

    return { status, message };
};

export const getStateData = async (showToast) => {
  try {
    const result = await axios.get(serviceEndPoint, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const getSiteError = async (showToast) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/error`, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const getStatesById = async (id, showToast) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/${id}`, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error,showToast);
  }
};

export const getSiteMemory = async (showToast) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/memory`, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const getStateLogsById = async (siteId, page = 1, limit = 10, showToast) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/logs/${siteId}`, {
      ...headerConfig(),
      params: { page, limit },
    });
    return result.data;
  } catch (error) {
    console.error("Error fetching logs:", error);
    return handleApiError(error, showToast) || { logs: [], currentPage: 1, totalPages: 1, totalLogs: 0 };
  }
};